export const Actions={

    GET_ALL_DELIVERABLES_DATA_SUCCESS:"GET_ALL_DELIVERABLES_DATA_SUCCESS",
    GET_ALL_DELIVERABLES_DATA_FAILED:"GET_ALL_DELIVERABLES_DATA_FAILED",
    GET_ALL_ASSOCIATED_TENANTS_SUCCESS:"GET_ALL_ASSOCIATED_TENANTS_SUCCESS",
    GET_ALL_ASSOCIATED_TENANTS_FAILED:"GET_ALL_ASSOCIATED_TENANTS_FAILED",
    GET_ALL_PROJECTS_DATA_SUCCES:"GET_ALL_PROJECTS_DATA_SUCCES",
    GET_ALL_PROJECTS_DATA_FAILED:"GET_ALL_PROJECTS_DATA_FAILED",
    GET_ALL_FILTERS_COUNT_SUCCESS:"GET_ALL_FILTERS_COUNT_SUCCESS",
    GET_ALL_FILTERS_COUNT_FAILED:"GET_ALL_FILTERS_COUNT_FAILED",
    UPDATE_PAGE_LOADING_STATE:"UPDATE_PAGE_LOADING_STATE",
    UPADTE_CREATE_DELIVERABLE_MODAL_STATE:"UPADTE_CREATE_DELIVERABLE_MODAL_STATE",
    GET_ALL_WORKSPACE_TENANT_DETAILS_SUCCESS:" GET_ALL_WORKSPACE_TENANT_DETAILS_SUCCESS",
    GET_ALL_WORKSPACE_TENANT_DETAILS_FAILED:" GET_ALL_WORKSPACE_TENANT_DETAILS_FAILED",
    CREATE_NEW_DELIVERABLE_SUCCESS:"CREATE_NEW_DELIVERABLE_SUCCESS",
    CREATE_NEW_DELIVERABLE_FAILED:"CREATE_NEW_DELIVERABLE_FAILED",
    UPDATE_CREATE_DELIVERABLE_STATE:"UPDATE_CREATE_DELIVERABLE_STATE",
    GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_SUCCESS:" GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_SUCCESS",
    GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_FAILED:" GET_ALL_WORKSPACE_PROJECTS_LIST_DETAILS_FAILED",
    UPDATE_DELIVERABLE_SUCCESS:"UPDATE_DELIVERABLE_SUCCESS",
    UPDATE_DELIVERABLE_FAILED:"UPDATE_DELIVERABLE_FAILED",
    PASSING_RECORD_DATA:"PASSING_RECORD_DATA",
    UPDATE_DELIVERABLE_CANCELED:"UPDATE_DELIVERABLE_CANCELED"
  }